import { CommonModule } from '@angular/common';
import { Component, Input, Signal, computed, signal } from '@angular/core';

interface ColorRange {
  threshold: number; // Value between 0 and 1
  color: string;
}

@Component({
  selector: 'ca-progress-bar',
  template: `
    <div class="progress-bar">
      <div
        class="progress"
        [style.width]="progress * 100 + '%'"
        [style.background-color]="colorSignal()"></div>
    </div>
  `,
  imports: [CommonModule],
})
export class ProgressBarComponent {
  private _progress = signal(0);
  private _colorMap: ColorRange[] = [
    { threshold: 0.25, color: 'red' },
    { threshold: 0.5, color: 'orange' },
    { threshold: 0.75, color: 'yellow' },
    { threshold: 1, color: 'green' },
  ];

  @Input()
  set progress(value: number) {
    if (value < 0 || value > 1 || isNaN(value)) {
      throw new Error('Progress must be a floating point number between 0 and 1.');
    }
    this._progress.set(value);
  }

  get progress(): number {
    return this._progress();
  }

  @Input()
  set colorMap(value: ColorRange[]) {
    if (!value || !Array.isArray(value) || value.length === 0) {
      throw new Error('colorMap must be a non-empty array of { threshold, color } objects.');
    }
    this._colorMap = value.sort((a, b) => a.threshold - b.threshold);
  }

  colorSignal: Signal<string> = computed(() => {
    const p = this._progress();
    return this._colorMap.find((c) => p <= c.threshold)?.color || 'gray';
  });
}
